<template>
    <div>
        <h2 style="margin-bottom:15px;">Termini e condizioni del servizio e gestione della privacy</h2>
         <v-spacer></v-spacer>

        <v-divider></v-divider>
        <div style="margin-top:15px;">
            <ul>
                <li>
                    <h3>Gestione dei Cookies</h3>
                    <p>Il sistema non fa utilizzo di cookies di tracciamento, sul nostro database vengono soltanto registrate le informazioni relative ad ogni prenotazione.</p>
                </li>
                <li>
                    <h3>Dati personali</h3>
                    <p>Il sistema di prenotazione registra nel proprio database il nome ed il numero di cellulare fornito dal cliente oltre alle informazioni sul servizio, la data e l'orario scelto.</p>
                </li>
                <li>
                    <h3>Utilizzo dati personali</h3>
                    <p>I dati personali verranno utilizzati solo al fine di poter individuare la persona che ha effettuato la prenotazione, in particolare il numero di cellulare potrà esser usato esclusivamente dal nostro personale per poter contattare il cliente nel caso in cui la prestazione per motivi straordinari non possa esser eseguita.</p>
                </li>
                <li>
                    <h3>Cessione di dati personali</h3>
                    <p>Nessun dato personale verrà ceduto a terzi, ne sarà utilizzato a scopi promozionali</p>
                </li>
                <li>
                    <h3>Distruzione dati personali dopo l'esecuzione della prestazione</h3>
                    <p>Il sistema renderà anonima ogni prenotazione trascorsi 14 giorni dalla data della prestazione, in base a quanto richiesto dalle normative Covid, eliminando dal database il relativo nome e numero di cellulare</p>
                </li>
                
            </ul>
       </div>
    </div>
</template>

<script>
export default {
    name: "error"
}
</script>